<template>
	<div class="app-container">
		<Toast position="top-right" />
		<router-view />
	</div>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;

  a {
	text-decoration: none;
  }
}

body {
	margin: 0;
}
</style>
